import axios from "axios";
import {urlAzure,url} from "../config";

export async function getOrdenesPendienteAprobacion(datalist, setValue, token,setLoading) {
    var data = JSON.stringify(datalist);
    var config = {
      method: 'post',
      url: `${urlAzure}api/OC/listAprobadorFinanzasPendiente`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: data
    };
    try {
      const response = await axios(config);
      const dataWithIds = response.data.map((item, index) => ({ ...item, id: index + 1 }));
      const sortedData = dataWithIds.sort((a, b) => a.id_oc_cabecera - b.id_oc_cabecera);
      setValue(sortedData);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }
  
  export async function getOrdenesPendienteAprobacionExcel(datalist, token) {
    var data = JSON.stringify(datalist);
    var config = {
        method: 'post',
        url: `${urlAzure}api/OC/listAprobadorFinanzasPendienteExport`,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data: data
    };
    const response = await axios(config);
    const dataWithIds = response.data.map((item, index) => ({ ...item, id: index + 1 }));
    return dataWithIds.sort((a, b) => a.id_oc_cabecera - b.id_oc_cabecera);
}


  export async function CrearOCEstado(datos,opcion,setLoadingGrid,token) {
    var data = JSON.stringify(datos);
    try {
      if(opcion==='aprobar'){
      var config = {
        method: 'post',
        url: `${urlAzure}api/OC/aprobarFinanzas`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: data
      };
    }else if(opcion==='observar'){
      var config = {
        method: 'post',
        url: `${urlAzure}api/OC/observarFinanzas`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: data
      };
    }else if(opcion==='rechazar'){
      var config = {
        method: 'post',
        url: `${urlAzure}api/OC/rechazarFinanzas`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: data
      };
    }
      const datos=await axios(config);
      console.log("Se insertó correctamente");
      console.log(datos.data);
    } catch (error) {
      console.error("Ocurrió un error al Aprobar:", error);
    } finally {
      setLoadingGrid(false);
    }
  }
  
  // Aprobar masivo finanzas
export const aprobarFinanzasMasiva = async (payload, token) => {
    const response = await fetch(`${urlAzure}api/OC/aprobarFinanzasMasiva`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
    });
    if (!response.ok) {
        const error = await response.text();
        throw new Error(error);
    }
    return true;
};

  export async function CrearOCEstadoBorrador(datos,opcion,setLoadingGrid,token) {
    var data = JSON.stringify(datos);
    try {
      if(opcion==='aprobar'){
      var config = {
        method: 'post',
        url: `${url}api/OC/CrearBorradorDelOC`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: data
      };
    }else if(opcion==='observar'){
      var config = {
        method: 'post',
        url: `${url}api/OC/CrearBorradorDelOC`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: data
      };
    }else if(opcion==='rechazar'){
      var config = {
        method: 'post',
        url: `${url}api/OC/CrearBorradorDelOC`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: data
      };
    }
      const datos=await axios(config);
      console.log("Se insertó correctamente");
      console.log(datos.data);
    } catch (error) {
      console.error("Ocurrió un error al Aprobar:", error);
    } finally {
      setLoadingGrid(false);
    }
  }

  // ─── ANÁLISIS DE PEDIDOS ──────────────────────────────────────────────────────
  /**
   * Obtiene el análisis de alertas de una OC por su docEntry.
   * @param {number} docEntry  - id_documento_borrador o id_oc_cabecera
   * @param {string} token     - JWT del usuario
   * @returns {Promise<object>} - objeto con resumenAlertas y lineas
   */
  export async function getAnalisisPedidos(docEntry, token) {
    const config = {
      method: 'get',
      url: `${urlAzure}api/OC/GetAnalisisPedidos`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      params: { docEntry },
    };
    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.error("Error al obtener análisis de pedidos:", error);
      return null;
    }
  }
  // ─────────────────────────────────────────────────────────────────────────────

  export async function getListFinanzasHistorial(datalist, setValue, token,setLoading) {
    var data = JSON.stringify(datalist);
    var config = {
      method: 'post',
      url: `${urlAzure}api/OC/listAprobadorFinanzas`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: data
    };
    try {
      const response = await axios(config);
      const dataWithIds = response.data.map((item, index) => ({ ...item, id: index + 1 }));
      const sortedData = dataWithIds.sort((a, b) => a.id_oc_cabecera - b.id_oc_cabecera);
      setValue(sortedData);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }
  
  export async function getListFinanzasHistorialExcel(datalist, setValue, token,setBtndisabled) {
    var data = JSON.stringify(datalist);
    var config = {
      method: 'post',
      url: `${urlAzure}api/OC/listAprobadorFinanzasExport`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: data
    };
    try {
      const response = await axios(config);
      const dataWithIds = response.data.map((item, index) => ({ ...item, id: index + 1 }));
      const sortedData = dataWithIds.sort((a, b) => a.id_oc_cabecera - b.id_oc_cabecera);
      setValue(sortedData);
      setBtndisabled(false);
    } catch (error) {
      console.error(error);
    }
  }

  export async function getListFinanzasLiberarDocumentosNE(datalist, setValue, token) {
    var data = JSON.stringify(datalist);
    var config = {
      method: 'post',
      url: `${urlAzure}api/NE/listEliminarPdf`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: data
    };
    try {
      const response = await axios(config);
      const dataWithIds = response.data.map((item, index) => ({ ...item, id: index + 1 }));
      const sortedData = dataWithIds.sort((a, b) => a.id_oc_cabecera - b.id_oc_cabecera);
      setValue(sortedData);
    } catch (error) {
      console.error(error);
    }
  }

  export async function getListFacturasRechazadas(dataList,setValue, token) {
    var data = dataList;
    var config = {
      method: 'post',
      url: `${urlAzure}api/NE/ListFacturasRechazadas`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: data
    };
    try {
      const response = await axios(config);
      const dataWithIds = response.data.map((item, index) => ({ ...item, id: index + 1 }));
      const sortedData = dataWithIds.sort((a, b) => a.id_oc_cabecera - b.id_oc_cabecera);
      setValue(sortedData);
    } catch (error) {
      console.error(error);
    }
  }

  export async function getListFacturasRechazadasExport(dataList,setValue, token) {
    var data = dataList;
    var config = {
      method: 'post',
      url: `${urlAzure}api/NE/ListFacturasRechazadasExport`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: data
    };
    try {
      const response = await axios(config);
      const dataWithIds = response.data.map((item, index) => ({ ...item, id: index + 1 }));
      const sortedData = dataWithIds.sort((a, b) => a.id_oc_cabecera - b.id_oc_cabecera);
      setValue(sortedData);
    } catch (error) {
      console.error(error);
    }
  }

  export async function getListFacturasAprobadas(dataList,setValue, token) {
    var data = dataList;
    var config = {
      method: 'post',
      url: `${urlAzure}api/NE/ListFacturasAprobadas`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: data
    };
    try {
      const response = await axios(config);
      const dataWithIds = response.data.map((item, index) => ({ ...item, id: index + 1 }));
      const sortedData = dataWithIds.sort((a, b) => a.id_oc_cabecera - b.id_oc_cabecera);
      setValue(sortedData);
    } catch (error) {
      console.error(error);
    }
  }

  export async function getListFacturasAprobadasExport(dataList,setValue, token) {
    var data = dataList;
    var config = {
      method: 'post',
      url: `${urlAzure}api/NE/ListFacturasAprobadasExport`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: data
    };
    try {
      const response = await axios(config);
      const dataWithIds = response.data.map((item, index) => ({ ...item, id: index + 1 }));
      const sortedData = dataWithIds.sort((a, b) => a.id_oc_cabecera - b.id_oc_cabecera);
      setValue(sortedData);
    } catch (error) {
      console.error(error);
    }
  }
  
  export async function getListFinanzasLiberarDocumentosNEExcel(datalist, token) {
    var data = JSON.stringify(datalist);
    var config = {
      method: 'post',
      url: `${urlAzure}api/NE/listEliminarPdfExport`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: data
    };
    try {
      const response = await axios(config);
      const dataWithIds = response.data.map((item, index) => ({ ...item, id: index + 1 }));
      const sortedData = dataWithIds.sort((a, b) => a.id_oc_cabecera - b.id_oc_cabecera);
      return sortedData;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  export async function deletePDF(data,setSnackbar, token) {
    try {
      var datos = data;
      const config = {
        method: 'post',
        url: `${urlAzure}api/NE/eliminarFactura`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: datos,
      };
  
      const response = await axios(config);
      setSnackbar('Se libero documento pendiente de volver adjuntar');
      return response.data;

    } catch (error) {
      setSnackbar('error');
      return null;
    }
  }

  export async function aprobarPDF(data,setSnackbar, token) {
    try {
      var datos = data;
      const config = {
        method: 'post',
        url: `${urlAzure}api/NE/aprobaciondefacturacontabilidad`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: datos,
      };
  
      const response = await axios(config);
      setSnackbar(response.data);
      return response.data;

    } catch (error) {
      setSnackbar(error);
      return null;
    }
  }


  export async function getListFacturasRechazadasArea(dataList,setValue, token) {
    var data = dataList;
    var config = {
      method: 'post',
      url: `${urlAzure}api/NE/ListFacturasRechazadasArea`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: data
    };
    try {
      const response = await axios(config);
      const dataWithIds = response.data.map((item, index) => ({ ...item, id: index + 1 }));
      const sortedData = dataWithIds.sort((a, b) => a.id_oc_cabecera - b.id_oc_cabecera);
      setValue(sortedData);
    } catch (error) {
      console.error(error);
    }
  }

  export async function getListFacturasRechazadasAreaExport(dataList,setValue, token) {
    var data = dataList;
    var config = {
      method: 'post',
      url: `${urlAzure}api/NE/ListFacturasRechazadasAreaExport`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: data
    };
    try {
      const response = await axios(config);
      const dataWithIds = response.data.map((item, index) => ({ ...item, id: index + 1 }));
      const sortedData = dataWithIds.sort((a, b) => a.id_oc_cabecera - b.id_oc_cabecera);
      setValue(sortedData);
    } catch (error) {
      console.error(error);
    }
  }

  export async function getListFacturasAprobadasArea(dataList,setValue, token) {
    var data = dataList;
    var config = {
      method: 'post',
      url: `${urlAzure}api/NE/ListFacturasAprobadasArea`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: data
    };
    try {
      const response = await axios(config);
      const dataWithIds = response.data.map((item, index) => ({ ...item, id: index + 1 }));
      const sortedData = dataWithIds.sort((a, b) => a.id_oc_cabecera - b.id_oc_cabecera);
      setValue(sortedData);
    } catch (error) {
      console.error(error);
    }
  }

  export async function getListFacturasAprobadasAreaExport(dataList,setValue, token) {
    var data = dataList;
    var config = {
      method: 'post',
      url: `${urlAzure}api/NE/ListFacturasAprobadasAreaExport`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: data
    };
    try {
      const response = await axios(config);
      const dataWithIds = response.data.map((item, index) => ({ ...item, id: index + 1 }));
      const sortedData = dataWithIds.sort((a, b) => a.id_oc_cabecera - b.id_oc_cabecera);
      setValue(sortedData);
    } catch (error) {
      console.error(error);
    }
  }
